<template>
    <div>
        <div class="white-box mt-3">
            <div v-if="!loading" class="data-group">
                <M3FormTitle title="Sinteza proiectului tău" class="mb-4" :checked="completed"></M3FormTitle>
                <!--                <SintezaSection
                    boldTitle="Crearea contului in MySmis"
                    title="schița proiect, obținere cod SMIS"
                    :checked="pageCompleted('cont-mysmis')"
                >
                </SintezaSection>-->
                <SintezaSection
                    boldTitle="Crearea contului in IMM Recover"
                    title="schița proiect, obținere cod IMM Recover"
                    :checked="pageCompleted('imm-recover')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Profilul companiei tale"
                    title="informatii despre companie și reprezentantul legal"
                    :checked="pageCompleted('compania-mea')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Proiectul tău"
                    title="informații despre proiectul tău de investiții"
                    :checked="pageCompleted('proiectul-meu')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Activități"
                    title="informații despre activitățile proiectului tău"
                    :checked="pageCompleted('activitati')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Obiective"
                    title="obiectivul general și obiectivele specifice"
                    :checked="pageCompleted('obiective')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Indicatori"
                    title="de realizare si rezultat"
                    :checked="pageCompleted('indicatori')"
                >
                </SintezaSection>
                <SintezaSection
                    boldTitle="Achiziții / cheltuieli"
                    title="achizițiile proiectului"
                    :checked="pageCompleted('achizitii-cheltuieli')"
                >
                </SintezaSection>
                <div>
                    <SintezaSection
                        boldTitle="Buget"
                        title="cheltuieli si bugetul proiectului"
                        :checked="pageCompleted('buget')"
                    >
                    </SintezaSection>
                    <div class="mini-item gray budgetCustom">
                        <p class="title">Bugetul <strong>minim</strong> / <strong>maxim</strong></p>
                        <apexchart type="rangeBar" width="500" height="100" :options="budgetChartOptions" :series="budgetSeries"></apexchart>
                        <img v-if="statistics.nerambursabil.EUR < 50000 || statistics.nerambursabil.EUR > statistics.max_budget" src="@/assets/images/M3/M3Sketch/danger-red.png">
                        <p :class="{'title': true, 'red-text': statistics.nerambursabil.EUR < 50000 || statistics.nerambursabil.EUR > statistics.max_budget, 'green-text': statistics.nerambursabil.EUR >= 50000 && statistics.nerambursabil.EUR <= statistics.max_budget}">Valorea ajutorului nerambursabil<br><br>Minim 50.000€<br>Maxim {{ formatPrice(statistics.max_budget) }}€</p>
                    </div>
                    <div class="flex space-between gap-10">
                        <div class="mini-item gray">
                        <p class="title">Valoarea cheltuielilor pentru <strong>Modernizarea spațiilor de producție/servicii</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.cheltuieli_constructii > 50}" :style="{'--value': statistics.cheltuieli_constructii + '%'}">
                                    <p>{{ Number.isInteger(statistics.cheltuieli_constructii) ? statistics.cheltuieli_constructii : statistics.cheltuieli_constructii.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.cheltuieli_constructii > 50" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.cheltuieli_constructii > 50, 'green-text': statistics.cheltuieli_constructii <= 50}">Valoarea cheltuielilor pentru (1.1) modernizarea spațiilor de producție/servicii nu poate depăși 50% din valoarea proiectului - <strong>criteriul {{ statistics.cheltuieli_constructii > 50 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                        <div class="mini-item gray">
                            <p class="title">Valoarea eligibilă a <strong>activelor necorporale</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.active_necorporale > 20}" :style="{'--value': statistics.active_necorporale + '%'}">
                                    <p>{{ Number.isInteger(statistics.active_necorporale) ? statistics.active_necorporale : statistics.active_necorporale.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.active_necorporale > 20" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.active_necorporale > 20, 'green-text': statistics.active_necorporale <= 20}">Valoarea eligibilă a activelor necorporale (3.2) nu poate depăși 20% din valoarea eligibilă a activelor corporale (3.1.1. + 3.1.2. + 3.1.3.) ce fac obiectul proiectului - <strong>criteriul {{ statistics.active_necorporale > 20 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                        <div class="mini-item gray">
                            <p class="title">Cheltuielile de <strong>consultanță</strong></p>
                            <div class="chart-block">
                                <div :class="{'chart chart-slim x-20': true, 'red-chart': statistics.cheltuieli_consultanta > 10}" :style="{'--value': statistics.cheltuieli_consultanta + '%'}">
                                    <p>{{ Number.isInteger(statistics.cheltuieli_consultanta) ? statistics.cheltuieli_consultanta : statistics.cheltuieli_consultanta.toFixed(2) }}%</p>
                                </div>
                            </div>
                            <img v-if="statistics.cheltuieli_consultanta > 10" src="@/assets/images/M3/M3Sketch/danger-red.png">
                            <p :class="{'title': true, 'red-text': statistics.cheltuieli_consultanta > 10, 'green-text': statistics.cheltuieli_consultanta <= 10}">Cheltuielile de consultanță (2.1. + 2.2. + 2.3.) pentru pregătirea și implementarea proiectului se vor încadra în limita a 10% din valoarea eligibilă a proiectului - <strong>criteriul {{ statistics.cheltuieli_consultanta > 10 ? 'nu' : '' }} este îndeplinit</strong></p>
                        </div>
                    </div>
                    <SintezaSection
                        boldTitle="Plan de afaceri"
                        title="pentru proiectul tău de investiții"
                        :checked="pageCompleted('plan-de-afaceri')"
                    >
                    </SintezaSection>
                    <SintezaSection
                        boldTitle="Cerere de finanțare"
                        title="detalii despre proiectul tău"
                        :checked="pageCompleted('cerere-de-finantare')"
                    >
                    </SintezaSection>

                </div>
            </div>
            <LoadingSpinner v-else></LoadingSpinner>
        </div>
    </div>
</template>

<script>
    import M3FormTitle from '../M3FormTitle'
    import SintezaSection from './SintezaSection'
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import api from '@/helpers/api';
    import axios from '@/helpers/axios';
    import { BForm, BFormInput, BIconPencilSquare, BIconTrash, BIconCheckCircleFill, BFormCheckbox,BIconXCircleFill} from "bootstrap-vue";
    export default {
        components: {
            BForm,
            BFormInput,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BFormCheckbox,
            M3FormTitle,
            BIconXCircleFill,
            SintezaSection,
            LoadingSpinner
        },
        data() {
            return {
                completed: false,
                completedList: false,
                loading: true,
                activeCompany: null,
                statistics: {
                    max_budget: 1000000,
                    nerambursabil: {EUR: 0},
                    cheltuieli_constructii: 0,
                    active_necorporale: 0,
                    cheltuieli_consultanta: 0
                },
                budgetSeries: [
                    {
                        name: 'Limite buget',
                        data: [
                            {
                                x: '',
                                y: [50000, 1000000],
                                goals: [
                                    {
                                        name: 'Valoare buget',
                                        value: 0,
                                        strokeWidth: 10,
                                        strokeHeight: 0,
                                        strokeLineCap: 'round',
                                        strokeColor: '#ff5555'
                                    }
                                ],
                                fillColor: '#0cc2aa'
                            },
                        ]
                    }
                ],
                budgetChartOptions: {
                    chart: {
                        height: 20,
                        type: 'rangeBar',
                        toolbar: {
                            show: false,
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                hideOverflowingLabels: true
                            },
                        }
                    },
                    dataLabels: {
                        enabled: false,
                        formatter: function() {
                            return ''
                        },

                    },
                    yaxis: {
                        show: false
                    },
                    xaxis: {
                        min: 0,
                        max: 1000000,
                        labels: {
                            formatter: function(val) {
                                let label = val
                                if (Number(label) >= 10000 && Number(label) < 1000000){
                                    label = Number(label) / 1000;
                                    label = label+'k';
                                }
                                if(Number(label) >= 1000000){
                                    label = Number(label) / 1000000;
                                    label = label+'M';
                                }
                                return label;
                            },
                        }
                    }
                },
            }
        },
        computed: {
            maxBudget() {
                return this.$store.getters['m3Sketch/maxBudget'];
            },
            isCompleted() {
                return this.$store.getters['pages/completed'].includes('sinteza')
            },
            pagesCompleted() {
                return this.$store.getters['pages/completed']
            }
        },
        watch: {
            pagesCompleted: {
                handler: function() {
                    this.completedList = this.pagesCompleted
                },
                deep: true
            },
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            if(this.$store.getters['pages/completed'] !== null){
                this.completedList = this.$store.getters['pages/completed']
                this.loading = false
            }
            this.activeCompany = JSON.parse(localStorage.getItem('currentM3Company')).id
            this.getStatistics();

            this.checkCompleted();
        },
        methods: {
            pageCompleted(page){
                if(this.completedList !== null){
                    /*if(page === 'buget'){
                        this.section = {
                            section: 'buget'
                        }
                        if(this.statistics.active_necorporale < 20 && this.statistics.cheltuieli_constructii < 50 && this.statistics.cheltuieli_consultanta < 20 && this.statistics.nerambursabil.EUR >= 50000 && this.statistics.nerambursabil.EUR <= this.statistics.max_budget){
                            if(this.completedList.includes(page))
                                return true;
                            else{
                                axios.post(api.API_ENDPOINTS.m3company + this.activeCompany + '/project/progress', this.section)
                                this.$emit('addToProgress', this.section)
                                this.checkCompleted('sinteza');
                            }
                        }
                        else{
                            axios.delete(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/project/progress', {
                                data: {
                                    section: 'buget'
                                }
                            })
                            this.$emit('removeFromProgress', this.section)
                        }
                    }*/
                    if(page === 'achizitii-cheltuieli') {
                        let acquisitions = this.$store.getters['m3Sketch/allData']
                        let completed = true
                        if(acquisitions && acquisitions.m3_project && acquisitions.m3_project.spendings) {
                            acquisitions.m3_project.spendings.forEach(category => {
                                category.subcategories.forEach(subcategory => {
                                    subcategory.acquisitions.forEach(spending => {
                                        if(!spending.offer_1.id || !spending.offer_2.id || (!spending.env_contr.id && spending.contribution_percentage > 0)) {
                                            completed = false
                                        }

                                    })
                                })
                            })
                        }
                        if(completed) {
                            return true
                        } else {
                            return false
                        }
                    }
                    else{
                        return this.completedList.includes(page)
                    }
                }

            },

            checkCompleted(){
                this.section = {
                    section: 'sinteza',
                    submit: true
                }

                if((this.$store.getters['pages/completed'].length === 11 && !this.$store.getters['pages/completed'].includes('sinteza')) || (this.$store.getters['pages/completed'].length === 12 && this.$store.getters['pages/completed'].includes('sinteza'))){
                    this.$store.dispatch('pages/addPage', this.section);
                    this.completed = true;
                }
                else{
                    this.$store.dispatch('pages/removePage', this.section);
                    this.completed = false;
                }
            },

            getStatistics(){
                if(this.activeCompany) {
                    axios.get(api.API_ENDPOINTS.m3company + this.activeCompany + '/project/indicators')
                        .then( response => {
                            this.statistics = response.data;

                            this.budgetSeries = [
                                {
                                    name: 'Limite buget',
                                    data: [
                                        {
                                            x: '',
                                            y: [50000, this.statistics.max_budget],
                                            goals: [
                                                {
                                                    name: 'Valoare buget',
                                                    value: this.statistics.nerambursabil.EUR,
                                                    strokeWidth: 10,
                                                    strokeHeight: 0,
                                                    strokeLineCap: 'round',
                                                    strokeColor: this.statistics.nerambursabil.EUR > 50000 && this.statistics.nerambursabil.EUR < this.statistics.max_budget ? '#846c89' : '#ff5555'
                                                }
                                            ],
                                            fillColor: '#0cc2aa'
                                        },
                                    ]
                                }
                            ]
                            this.$store.dispatch('pageLoading/setLoading', false)
                        })
                }
            },

            getBudgetChartPercentage() {
                return ((this.statistics.nerambursabil.EUR - 50000) * 100 / 950000).toFixed(2);
            },

            kFormatter(number) {
                var SI_SYMBOL = ["", " k", " M"];
                var tier = Math.log10(Math.abs(number)) / 3 | 0;

                // if zero, we don't need a suffix
                if(tier == 0) return number;

                // get suffix and determine scale
                var suffix = SI_SYMBOL[tier];
                var scale = Math.pow(10, tier * 3);

                // scale the number
                var scaled = number / scale;

                // format number and add suffix
                return scaled.toFixed(1) + suffix;
            },

            formatPrice(price) {
                price = price.toString().replace('.', ',');
                var pattern = /(-?\d+)(\d{3})/;
                while (pattern.test(price))
                    price = price.replace(pattern, "$1.$2");
                return price;
            },

            budgetIsFulfilled() {
                return this.statistics.nerambursabil.EUR >= 50000 && this.statistics.nerambursabil.EUR <= this.statistics.max_budget;
            }
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
}
.flex{
    display: flex;
}

.check{

    fill: #49cda8;
}
.deny{
    fill: #ff6767;
}
.warning_text{
    color:#ff6767; ;
}
.mini-item{
    margin: 20px 0 10px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px !important;
}
.mini-item .title{
    text-align: center;
    color: #253646;
    font-size: 14px;
    min-height: 63px;
    margin-bottom: 15px;
}
.mini-item .title:last-child{
    margin-top: 26px;
}
.space-between{
    justify-content: space-between;
}
.gray{
    background: #f6f7f8;
    width: 100%;
    padding: 10px 30px;
    font-size: 14px;
}
.chart-block{
    min-height: 80px;
}
.green-text{
    color: #0cc2aa !important;
}
.red-text{
    color: #ff7474 !important;
}
.red-chart{
    background-image: conic-gradient(#ff7474 var(--value), transparent var(--value)) !important;
}
.red-chart p{
    color: #ff7474 !important;
}
.chart {
    width: 65px;
    height: 65px;
}
.chart-slim {
    margin-right: 0px;
}
.chart-slim p{
    /* font-weight: 700 !important; */
    font-size: 14px !important;
    letter-spacing: -0.6px;
    color: #0cc2aa;
}
.gap-10{
    gap:10px
}
@media(max-width:1500px){
    .gap-10{
        gap:10px;
        flex-wrap: wrap;
        margin-top: 20px;
    }
    .mini-item{
        max-width: none;
        flex-basis: 48%;
        margin-top: 0;
    }

}
@media(max-width:1200px){
    .gap-10{
        gap:10px;
        flex-wrap: wrap;
        margin-top: 20px;
    }
    .mini-item{
        max-width: none;
        flex-basis: 100%;
        margin-top: 0;
    }

}
.budgetCustom{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end
}
@media (max-width: 1300px) {
  .budgetCustom{
    flex-direction: column!important;
    align-items: center!important;
  }
}
</style>
